import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import ExerciseStaticsOption from "../ExerciseStaticsOption";
import { BaseQuestionType, EndExerciseQuestion } from "service/question";
import moment from "moment";
import { Button, Tag } from "antd";
import { useNavigateQuestion } from "../../../../../../service/stores/Question/Statics";
interface TopicDetailProps {
    index: number;
    data: EndExerciseQuestion;
    subQuestion?: boolean;
}

export default function TopicDetail({
    index,
    data,
    subQuestion = false
}: TopicDetailProps) {
    const [current, setCurrent] = useState(0);

    function next() {
        if (current === data.stuAnswer.length - 1) {
            return;
        }
        setCurrent(current + 1);
    }

    function prev() {
        if (current === 0) {
            return;
        }
        setCurrent(current - 1);
    }

    const { selectedIndex } = useNavigateQuestion();

    useEffect(() => {
        setCurrent(0);
    }, [selectedIndex]);

    return (
        <div className={style.root}>
            <div className={style.info}>
                {subQuestion ? <em>({index + 1}).</em> : <em>{index + 1}.</em>}
                {data.queTypeName}
            </div>
            <div
                className={style.trunk}
                dangerouslySetInnerHTML={{ __html: data.contentText }}
            />

            {[
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice
            ].includes(data.queTypeId) && (
                <div className={style.options}>
                    {data.optionModelList?.map((option, index) => (
                        <ExerciseStaticsOption
                            key={option.id}
                            data={option}
                            index={index}
                        />
                    ))}
                </div>
            )}
            {data.queTypeId === BaseQuestionType.Subjective && (
                <div className={style.box}>
                    <div className={style.flex}>
                        <div className={style.tips}>
                            共 {data?.stuAnswer?.length} 人提交此问题
                            <Tag>
                                {moment(
                                    data?.stuAnswer[current]?.submitTime
                                ).format("YYYY-MM-DD HH:mm:ss")}
                            </Tag>
                        </div>
                        <div>
                            <Button
                                onClick={prev}
                                size="small"
                                style={{ marginRight: 15 }}>
                                上一份
                            </Button>
                            <Button
                                style={{ marginRight: 15 }}
                                onClick={next}
                                size="small">
                                下一份
                            </Button>
                            <span>
                                {current + 1}/{data?.stuAnswer?.length}
                            </span>
                        </div>
                    </div>
                    <div
                        className={style.con}
                        dangerouslySetInnerHTML={{
                            __html: data?.stuAnswer[current]?.answer
                        }}
                    />
                </div>
            )}
        </div>
    );
}
